
import { defineComponent } from "vue";

export default defineComponent({
	name: "ModalWindow",
	emits: ["update:modelValue"],
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
		title: {
			type: String,
			default: "",
		},
		type: {
			type: String,
			default: "default",
		},
	},
	watch: {
		modelValue(value) {
			document.body.style.overflowY = value ? "hidden" : "auto";
		},
	},
	methods: {
		close() {
			this.$emit("update:modelValue", false);
		},
	},
});
